'use client';

import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import useDevice from '@/hooks/useDevice';
import AwardsAccordeon from './AwardsAccordeon';
import AwardsTable from './AwardsTable';
import { AwardsDto } from './interface';
interface Props {
  data: AwardsDto;
}
const AboutUsAwards: FC<Props> = t0 => {
  const $ = _c(3);
  const {
    data
  } = t0;
  const device = useDevice();
  let t1;
  if ($[0] !== data || $[1] !== device) {
    t1 = device === "mobile" ? <AwardsAccordeon data={data} /> : <AwardsTable data={data} />;
    $[0] = data;
    $[1] = device;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default AboutUsAwards;